<template>
<div class="topbar">
<div class="w1200 bc">
<ul class="topbar-right fr">
<li v-if="isLogin==true">
Hello <span></span>
</li>
<li v-if="isLogin==true">
<a class="co2" :href="userCenterUrl">{{account}}</a>
</li>
<li v-if="isLogin==true">
<a class="co2" @click="logout()">[Sign out]</a>
</li>
<li>
						<a :href="aboutUsUrl">About Us</a>
					</li>
					<li>
						<a :href="contactUrl"  target="_blank">Customer Service</a>
					</li>
					<li>
						<a href="http://www.baomate.com"  target="_blank">Chinese</a>
					</li>
</ul>
<ul class="topbar-left fl">
<li>
						Hello! Welcome to Baomate!
</li>
<!--<li>
<a class="co1" :href="indexUrl">Return to Baomate</a>
</li>-->
<li v-if="isLogin==false">
<a class="co2" :href="loginUrl">[Login]</a>
</li>
<li v-if="isLogin==false">
<a class="co2" :href="registerUrl">[Register]</a>
</li>
</ul>
</div>
</div>

</template>

<script>
	import {getCmsUrl,getIndexUrl,getUcUrl,getAboutUsUrl,sysContactUrl} from "../../static/js/emallUtils.js"
	import API from "../../static/api/api.js"
	export default {
		name: 'topbar',
		data() {
			return{
				isLogin:false,
				isShow:false,
				account:'',
				userCenterUrl:'',
				loginUrl:'',
				registerUrl:'',
				logoutUrl:'',
				aboutUsUrl:'',
				indexUrl:'',
				contactUrl:''
			}
		},
		methods:{
			logout:function(){
				localStorage.clear();
				API.loginOut(function(ret){});
				window.location.href = this.logoutUrl;
			},
			clearCookie:function(){
				var keys=document.cookie.match(/[^ =;]+(?=\=)/g); 
				if (keys) { 
				for(var i = keys.length; i--;) 
					document.cookie=keys[i]+'=0;expires=' + new Date( 0).toUTCString() 
				} 
			},
			jumpTo:function(name){
		  		this.$router.push({ name:name});
		  	},
		  	mobileAppShow:function(){
		  		this.isShow = true;
		  	},
		  	mobileAppHidden:function(){
		  		this.isShow = false;
		  	},
		  	getCookie:function(name) {
		        var bikky = document.cookie;
		        name += "=";
		        var i = 0; 
		        while (i < bikky.length){
		          var offset = i + name.length;
		          if (bikky.substring(i, offset) == name){ 
		            var endstr = bikky.indexOf(";", offset); 
		            if (endstr == -1) endstr = bikky.length;
		              return unescape(bikky.substring(offset, endstr)); 
		          }
		          i = bikky.indexOf(" ", i) + 1; 
		          if (i == 0) break; 
		        }
		        return null; 
		    }
		},
		mounted(){
			var that = this;
			var account = this.getCookie("r_userAgent_account");
			if(account != undefined && account != null && account != ""){
				that.isLogin = true;
				that.account = account;
			}
			
			that.userCenterUrl = getUcUrl() + '/index/default.htm';
			that.loginUrl = getUcUrl() + '/login.htm';
//			that.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
			that.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
			that.logoutUrl = getUcUrl() + '/logout.htm';
			that.aboutUsUrl = getAboutUsUrl();
			that.indexUrl = getIndexUrl();
			that.contactUrl = sysContactUrl;
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/TopBar.vue